import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import EditBatchComp from "./Component/EditBatchComp"


const EditBatch =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <EditBatchComp />
        </div>
        <Footer />
        </>
    )
}

export default EditBatch